import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DivVisibilityService {
  private visibilitySource = new BehaviorSubject<boolean>(true);
  visibility$ = this.visibilitySource.asObservable();

  // Métodos para mostrar y ocultar el div
  showDiv() {
    this.visibilitySource.next(true);
  }

  hideDiv() {
    this.visibilitySource.next(false);
  }
}
